import { Command } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { Output } from '../../output.js';
import { V2ApiError } from '../../api/v2-errors.js';
import { addGridOption, gridSlug, type GridOpts } from '../../grid-opt.js';

const SLUG_RE = /^[a-z][a-z0-9-]{2,39}$/;

interface CreateOpts extends GridOpts { description?: string; json?: boolean; }

export async function runSpaceCreate(name: string, opts: CreateOpts, client?: IV2Client): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false });
  if (!SLUG_RE.test(name) || name === 'general') {
    throw new V2ApiError(400, 'VALIDATION_FAILED',
      `Invalid slug '${name}'. Must be 3-40 lowercase a-z0-9-, start with a letter, and not be 'general'.`);
  }
  const c = client ?? await getV2Client(gridSlug(opts));
  const space = await c.post<{ slug: string; name: string }>('/api/v2/spaces', {
    slug: name, name, description: opts.description,
  });
  out.json(() => space);
  out.human(() => `✓ Created space: ${space.slug}\nAdd members: cloudgrid space invite ${space.slug} <email>`);
}

export const spaceCreateCommand = new Command('create')
  .description('Create a new space (admin only)')
  .argument('<name>', 'Space slug (3-40 lowercase alphanumeric/hyphens)')
  .option('--description <text>', 'Description (<=500 chars)')
  .option('--json', 'JSON output');
addGridOption(spaceCreateCommand, 'Override active grid');
spaceCreateCommand
  .action(async (name: string, opts: CreateOpts) => {
    try { await runSpaceCreate(name, opts); }
    catch (err) { await handleV2Error(err, { json: !!opts.json }); }
  });
